import {
  approveVideoSubTitle,
  createSubTitle,
  updateSubTitle,
  uploadSubtitleVideo,
} from "../../api/subTitle";
import { setIdle, setLoading } from "../../store/common/appStateSlice";
import {
  setSubTitle,
  setSubTitleInfo,
  setUploadedVideo,
} from "../../store/Subtitle/subTitleSlice";
import { showToast } from "../../utils/general";

export const createSubtitle = (data, cb) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const subTitle = await createSubTitle(data);
    dispatch(setSubTitle(subTitle?.data?.data || []));
    showToast(
      "Captions have been saved. You can now generate the video. ",
      "",
      "success"
    );
    dispatch(
      setSubTitleInfo({
        fileId: subTitle?.data?.fileId,
        taskId: subTitle?.data?.taskId,
        videoId: subTitle?.data?.videoId,
      })
    );

    dispatch(setIdle());
    if (cb) {
      cb();
    }
  } catch (error) {
    console.error("Error while creating subtitle", error);
    showToast("Something went wrong", "", "danger");
    dispatch(setIdle());
  }
};

export const uploadSubTitleVideo = (data, user_id, cb) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const uploadedFile = await uploadSubtitleVideo(user_id, data);
    if (cb) {
      cb();
    }
    showToast("Video uploaded successfully. ", "", "success");
    dispatch(setUploadedVideo(uploadedFile));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error while creating subtitle", error);
    dispatch(setIdle());
  }
};

export const updateVideoSubTitle = (data, cb) => async (dispatch) => {
  try {
    dispatch(setLoading());
    await updateSubTitle(data);
    dispatch(setIdle());
    showToast("Subtitle updated successfully ", "", "success");
    if (cb) {
      cb();
    }
  } catch (error) {
    console.error("Error while updating subtitle", error);
    showToast("Something went wrong", "", "danger");
    dispatch(setIdle());
  }
};

export const approveSubTitle = (data, cb) => async (dispatch) => {
  try {
    dispatch(setLoading());
    await approveVideoSubTitle(data);
    dispatch(setIdle());
    if (cb) {
      cb();
    }
  } catch (error) {
    console.error("Error while approving subtitle", error);
    dispatch(setIdle());
  }
};
